var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCometBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22482_6350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5177 0.553622C11.9112 0.880481 9.64523 2.36572 8.29664 4.63779L1.59225 16.3087C1.42744 16.5957 1.48514 16.959 1.73095 17.1808C1.97676 17.4026 2.34618 17.4211 2.61262 17.2295L5.48006 15.1627L0.112638 23.3988C-0.0672682 23.6776 -0.0288307 24.0443 0.206013 24.2784C0.443013 24.5154 0.809951 24.5497 1.08492 24.3718L9.3225 19.0059L7.25709 21.8726C7.06345 22.1418 7.08267 22.5091 7.30514 22.7549C7.52625 23 7.88742 23.0591 8.1772 22.8936L19.8557 16.1844C22.1203 14.8399 23.6062 12.5734 23.933 9.96476C24.6191 4.4929 19.9303 -0.141207 14.5177 0.553622Z",
    fill: "url(#paint0_linear_22482_6350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5614 3.30029C12.4591 3.30029 9.9364 5.82371 9.9364 8.92529C9.9364 12.0269 12.4591 14.5503 15.5614 14.5503C18.6637 14.5503 21.1864 12.0269 21.1864 8.92529C21.1864 5.82371 18.6637 3.30029 15.5614 3.30029ZM14.1544 11.7377C13.7661 11.7377 13.4513 11.4229 13.4513 11.0346C13.4513 10.6463 13.7661 10.3314 14.1544 10.3314C14.5429 10.3314 14.8576 10.6463 14.8576 11.0346C14.8576 11.4229 14.5429 11.7377 14.1544 11.7377ZM15.5607 9.62832C15.1724 9.62832 14.8576 9.31351 14.8576 8.9252C14.8576 8.53689 15.1724 8.22207 15.5607 8.22207C15.9491 8.22207 16.2638 8.53689 16.2638 8.9252C16.2638 9.31351 15.9491 9.62832 15.5607 9.62832ZM16.9669 11.7377C16.5786 11.7377 16.2638 11.4229 16.2638 11.0346C16.2638 10.6463 16.5786 10.3314 16.9669 10.3314C17.3554 10.3314 17.6701 10.6463 17.6701 11.0346C17.6701 11.4229 17.3554 11.7377 16.9669 11.7377Z",
    fill: "url(#paint1_linear_22482_6350)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22482_6350",
    x1: -0.00012207,
    y1: 12.4844,
    x2: 23.9999,
    y2: 12.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22482_6350",
    x1: 9.9364,
    y1: 8.92529,
    x2: 21.1864,
    y2: 8.92529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE2FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22482_6350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.484375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCometBlueIcon);
export default __webpack_public_path__ + "static/media/comet-blue-icon.b40ee87ec0e3b4337159e611c554dd8e.svg";
export { ForwardRef as ReactComponent };